import { AttributeGroupItem } from '@atom/types/form';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  header: string;
  formAttributeGroups: AttributeGroupItem[];
}

const FormAttributesTextbox = ({ header, formAttributeGroups }: Props) => {
  const renderAttributeRow = () => {
    return formAttributeGroups.map(group => {
      if (group.name === header) {
        return group.attributes.map(attribute => {
          return (
            <tr key={attribute.id} className={classes.textboxTableRow}>
              <td
                className={classes.textboxTableRowTitle}
                style={{ width: '15rem' }}
              >
                {attribute.name}:
              </td>
              <td className={classes.value}>
                {attributeDisplayUtility.display(
                  attribute.value,
                  attribute.dataType,
                  attribute.unit,
                )}
              </td>
            </tr>
          );
        });
      }
      return <></>;
    });
  };

  return (
    <table className={classes.collapseBorder}>
      <thead>
        <tr>
          <th className={classes.textboxTableTitle} colSpan={2}>
            {header}
          </th>
        </tr>
      </thead>
      <tbody className={classes.content}>{renderAttributeRow()}</tbody>
    </table>
  );
};

export default FormAttributesTextbox;
